module.exports = __webpack_public_path__ + "static/media/tn.89a384a0.svg";